export const YEAR_IN_DAYS = 365;
export const WEEK_IN_DAYS = 7;
export const MONTH_IN_DAYS = 30;

export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
// ts-prune-ignore-next-line
export const HOUR_IN_SECONDS = 3600;
export const TEN_MINUTES_IN_MS = 10 * 60 * SECOND;
export const YEAR_IN_SECONDS = 24 * HOUR_IN_SECONDS * YEAR_IN_DAYS;
export const WEEK_IN_SECONDS = 24 * HOUR_IN_SECONDS * WEEK_IN_DAYS;
